module.exports = __webpack_public_path__ + "img/upload-3rd-10.16550762.png";